export default "__VITE_ASSET__CxbhPBZM__"